import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  notificationRequests: [],
  vendorInfo:[],
  taxInfo:[],
  //profileImageUploaded:false
};
export default function useraccountReducer(state = initialState, action) {

  switch (action.type) {
    case types.GET_NOTIFICATION_INFO:
      return (assign({}, state, {
        notificationRequests: action.notificationRequests
      }));

    case types.GET_VENDOR_INFO:
       return (assign({}, state, {
        vendorInfo: action.vendorInfo
      }));


   /* case types.PROFILE_IMAGE_UPDATED:
       return (assign({}, state, {
        profileImageUploaded: action.profileImageUploaded
      }));*/
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/useraccountReducer.js